<template>
  <div id="atm-work" class="container">
    <main class="main-content">
      <article class="main">
        <QuickLink />
      </article>
      <article class="sub" style="padding-top: 0;">
        <template v-if="getAtmCollectStep === 1">
          <template v-if="isEmpty(getStoreAtmInfo)">
            <QrReader
              ref="qrReader"
              msg="ATM의 QR 코드를 잡아주세요."
              @captureQrData="gotAtmId"
            />
          </template>
          <br />
          <div class="taC">
            <br />
            <button class="btn btn_type_01" @click="activeCamera">촬영</button>
          </div>
        </template>
        <template v-if="getAtmCollectStep === 2">
          <div class="grid-container">
            <div style="grid-column: 1 / 3;">
              <DxTextBox
                :readOnly="true"
                fontSize="20px"
                height="35px"
                v-model="getStoreAtmInfo.dlvd_id"
              />
            </div>
            <div style="display: flex; justify-content: center;">
              <button
                class="btn btn_type_01 font13"
                @click="handleOpenAtmClick"
              >
                수납함 열림
              </button>
            </div>
          </div>
        </template>
        <template v-if="getAtmCollectStep === 3">
          <List
            :releaseList="releaseList"
            :atmName="getStoreAtmInfo.atm_name"
            @callCollectApi="callCollectApi"
            @imageUpload="handleImageUpload"
          />
        </template>
      </article>
    </main>
  </div>
</template>

<script>
import QuickLink from '@/components/QuickLink.vue'
import QrReader from '@/components/QrReader.vue'
import List from './list.vue'
import isEmpty from 'lodash/isEmpty'

import DxTextBox from 'devextreme-vue/text-box'

export default {
  name: 'AtmCollect',
  components: {
    QuickLink,
    List,
    DxTextBox,
    QrReader
  },
  data: () => ({
    releaseList: [],
    filesReders: [],
    files: []
  }),
  computed: {
    getErrMsg () {
      return window.$store.getters['AtmWsStore/getErrMsg']
    },
    getStoreAtmId () {
      return window.$store.getters['AtmWsStore/getReqAtmId']
    },
    getStoreAtmInfo () {
      return window.$store.getters['AtmWsStore/getResAtmInfo']
    },
    getAtmCollectStep () {
      return window.$store.getters['AtmWsStore/getAtmCollectStep']
    },
    getJobStartDateTime () {
      return window.$store.getters['AtmWsStore/getJobStartDateTime']
    },
    getDoorOpenDateTime () {
      return window.$store.getters['AtmWsStore/getDoorOpenDateTime']
    },
    getRoutePath () {
      return this.$route.path
    }
  },
  created () {
    if (this.getAtmCollectStep !== 1) {
      this.stepAction(this.getAtmCollectStep)
    }
  },
  mounted () {
    setTimeout(() => {
      console.log('mounted')
      this.$refs.qrReader.activeCamera()
    }, 100)

    document.getElementsByClassName('top')[0].hidden = true
  },
  beforeDestroy () {
    document.getElementsByClassName('top')[0].hidden = false
  },
  watch: {
    getAtmCollectStep (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.stepAction(newVal)
      }
    },
    getRoutePath (newVal, oldVal) {
      if (newVal !== oldVal && newVal === '/atm/collect') {
        console.log('route path')
        this.$refs.qrReader.activeCamera()
      }
    }
  },
  methods: {
    isEmpty,
    activeCamera () {
      this.setStoreAtmId('')
      this.$refs.qrReader.activeCamera()
    },
    gotAtmId (atmId) {
      this.setStoreAtmId(atmId)
    },
    setStoreAtmId (atmId) {
      this.$store.commit('AtmWsStore/setReqAtmId', atmId)
    },
    setStoreAtmInfo (atmInfo) {
      this.$store.commit('AtmWsStore/setResAtmInfo', atmInfo)
    },
    setStoreAtmCollectStep (step) {
      this.$store.commit('AtmWsStore/setAtmCollectStep', step)
    },
    stepAction (step) {
      switch (step) {
        case 1:
          this.setStoreAtmId('')
          break
        case 3:
          this.getreleaseList()
          break
      }
    },
    noticeToAtm (params) {
      return window.$store.dispatch('AtmWsStore/noticeToAtm', params)
    },
    async handleOpenAtmClick () {
      const res = await this.noticeToAtm({ atmId: this.getStoreAtmId, jobDvsnCode: 'door_open' })
      if (res) {
        const { data: { status, result } } = res
        if (status === '200' && result === 200) {
          this.setStoreAtmCollectStep(3)
        } else {
          this.$Alert.alert(this.getErrMsg[result]).then(() => {
            this.setStoreAtmInfo({})
            this.setStoreAtmId('')
            this.setStoreAtmCollectStep(1)
          })
        }
      }
    },
    async getreleaseList () {
      const res = await this.$http.get(`/api/purchase/atm/release/${this.getStoreAtmId}`)

      if (res) {
        const { data: { status, result } } = res
        if (status === '200') {
          const { resList } = result
          this.$store.commit('AtmWsStore/setBosCollectCnt', resList ? resList.length : 0)
          this.releaseList = resList.map(obj => {
            const regDate = obj.reg_date.split(' ')
            return {
              ...obj,
              reg_date: `${regDate[0]} ${regDate[1].substring(0, 5)}`
            }
          })
        }
      }
    },
    async callCollectApi (emitParam) {
      const param = {
        ...emitParam,
        atm_id: this.getStoreAtmId,
        lgn_dt: this.getJobStartDateTime,
        door_open_dt: this.getDoorOpenDateTime
      }
      const formData = new FormData()
      for (let item in param) {
        if (item === 'image_files') {
          param[item].forEach(file => {
            formData.append(`${item}`, file)
          })
        } else {
          formData.append(`${item}`, param[item])
        }
      }

      const res = await this.$http.post(`/api/purchase/atm/release`,
        formData,
        {
          'Content-Type': 'multipart/form-data'
        }
      )

      if (res) {
        const { data: { result, status } } = res
        if (status === '200') {
          const { msg } = result
          this.$Alert.alert(msg).then(() => {
            this.getreleaseList()
            this.$store.commit('AtmWsStore/setWorkCollectCnt', emitParam.cnt_release)
          })
        }
      }
    },
    handleImageUpload (param) {
      const fileParam = param.files

      const image_files = []

      for (let idx in fileParam) {
        const type = fileParam[idx].type
        if (type) {
          image_files.push(fileParam[idx])
        }
      }

      this.callCollectApi({
        ...param,
        image_files
      })
    },
    showImageModal (fileParam) {
      this.$modal.show('imageViewer', fileParam)
    }
  }
}
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 2px;
    margin-bottom: 10px;
}
.main .quick-link {
  height: 150px;
}
</style>

<style>
#atm-work .dx-widget input {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/atm/collect/index.vue